<template>
    <div class="container-wrapper">
        <div class="layout-banner">
            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/intelligence_banner.png"
                alt="" />
            <div class="text-block">
                <div class="title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">人工智能云平台</div>
                <div class="desc wow fadeInUp" data-wow-delay="0.5s">
                    『学』以致『用 』
                </div>
                <!-- <div class="use-button  wow fadeInUp" data-wow-delay="0.7s" @click="openCodeDialog">申请试用</div> -->
            </div>
        </div>

        <div class="block-wrap">
            <!-- <div class="block-title">平台功能</div>
        <div class="block-content mobile-function">
            <mobileCarousel></mobileCarousel>
        </div> -->
            <div class="block-content pc-function">
                <div class="content-row">
                    <div class="row-left img-wrapper wow fadeInLeft">
                        <div class="img-wrap">
                            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_advantage1.png"
                                alt="">
                        </div>
                    </div>
                    <div class="row-right wow text-wrapper  fadeInRight ">
                        <div class="block-text  text-wrap">
                            <div class="title">图像分析<span>更全面</span>、算法识别<span>更精准</span></div>
                            <div class="desc">
                                <div class="desc-row ">
                                    <div class="desc-column">
                                        <div class="desc-column-value">100+</div>
                                        <div class="desc-column-title">识别类别</div>
                                    </div>

                                    <div class="desc-column">
                                        <div class="desc-column-value">>95%</div>
                                        <div class="desc-column-title">检测精度</div>
                                    </div>

                                    <div class="desc-column">
                                        <div class="desc-column-value">300W+</div>
                                        <div class="desc-column-title">识别次数</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="content-row">
                    <div class="row-left wow text-wrapper fadeInLeft">
                        <div class="block-text draw">
                            <div class="title ">样本勾绘</div>
                            <div class="desc">自动特征工程</div>
                        </div>
                    </div>
                    <div class="row-right wow fadeInRight img-wrapper">
                        <div class="img-wrap">
                            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_advantage2.png"
                                alt="">
                        </div>
                    </div>
                </div>

                <div class="content-row">
                    <div class="row-left wow fadeInLeft img-wrapper">
                        <div class="img-wrap">
                            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_advantage3.png"
                                alt="">
                        </div>
                    </div>
                    <div class="row-right wow text-wrapper fadeInRight">
                        <div class="block-text draw">
                            <div class="title">样本增强</div>
                            <div class="desc">自动数据增强</div>
                        </div>
                    </div>
                </div>

                <div class="content-row">
                    <div class="row-left text-wrapper wow fadeInLeft">
                        <div class="block-text draw">
                            <div class="title">模型自动化训练</div>
                            <div class="desc">大规模视觉预训练模型</div>
                        </div>
                    </div>
                    <div class="row-right wow img-wrapper fadeInRight">
                        <div class="img-wrap">
                            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_advantage4.png"
                                alt="">
                        </div>
                    </div>
                </div>

                <div class="content-row">
                    <div class="row-left wow fadeInLeft img-wrapper">
                        <div class="img-wrap">
                            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_advantage5.png"
                                alt="">
                        </div>
                    </div>
                    <div class="row-right wow fadeInRight text-wrapper">
                        <div class="block-text draw ">
                            <div class="title">焱图人工智能识别平台</div>
                            <div class="desc">让AI触手可及</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 应用场景 -->
        <div class="application-scenarios">
            <div class="application-title page-block-title">领先的图像分析算法，行业应用场景丰富</div>
            <div class="application-content">
                <div class="application-block">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_application1.png"
                        class="pc-img" alt="">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/scene_img1.png"
                        class="mobile-img" alt="">
                    <div class="text">智慧能源</div>
                </div>

                <div class="application-block">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_application2.png"
                        class="pc-img" alt="">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/scene_img2.png"
                        class="mobile-img" alt="">
                    <div class="text">智慧城管</div>
                </div>

                <div class="application-block">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_application3.png"
                        class="pc-img" alt="">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/scene_img3.png"
                        class="mobile-img" alt="">

                    <div class="text">智慧国土</div>
                </div>

                <div class="application-block">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_application4.png"
                        class="pc-img" alt="">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/scene_img4.png"
                        class="mobile-img" alt="">

                    <div class="text">罂粟花查处</div>
                </div>

                <div class="application-block">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_application5.png"
                        class="pc-img" alt="">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/scene_img5.png"
                        class="mobile-img" alt="">
                    <div class="text">智慧交通</div>
                </div>

                <div class="application-block">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/basic/intelligence_application6.png"
                        class="pc-img" alt="">
                    <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/scene_img6.png"
                        class="mobile-img" alt="">
                    <div class="text">智慧电力</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
    data() {
        return {}
    },
    mounted() {
        this.$nextTick(() => {
            new WOW().init();
        });
    },
}
</script>

<style lang="stylus" scoped>
.container-wrapper {
    width:100%;
    @keyframes zoomIn {
            0% {
              transform: scale(1.1); 
            }
            100% {
                transform: scale(1); 
            }
        }
    .layout-banner {
        height:100vh;
        position:relative;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;

        }
        .text-block {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            z-index: 2;
            color:#fff;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                white-space: wrap;
                font-size:1.25rem;
                text-align:center;
                line-height:35px;
            }
            .use-button {
                width:9rem;
                height:2.875rem;
                cursor:pointer;
                font-size:1.125rem;
                letter-spacing:1px;
                background: #2372E9;
                line-height:2.875rem;
                text-align:center;
                margin-top:6.18rem;
                border-radius:30px;
            }
        }
    }
    .block-wrap {
        width:100%;
        position:relative;
        padding-top:4.625rem;
        .block-title {
            position:relative;
            font-size:2.625rem;
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
        .block-title::after {
            content:"";
            position:absolute;
            width: 55px;
            left:50%;
            transform:translateX(-50%);
            top:80px;
            height: 3px;
            background: #2372E9;
            }
            .block-desc {
                margin:4.625rem auto 3.75rem;
                line-height:32px;
                font-size:1.25rem;
                color:#666666;
                text-align:center;
            }
    }
    .content-wrap {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto;
        padding-bottom:5.8rem;
        text-align:center;
        img {
            width:1134px;
        }
        .product-row {
            display:flex;
            justify-content:center;
            margin-top:4.93rem;
            .product-column {
                width:31%;
                min-width:27rem;
                margin-right:2.5rem;
            }
            .top-img {
                background-color:#E6E6E6;
                height:15.58rem;
                background-repeat:no-repeat;
                background-position:center;
            }
            .fly-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img1.png");
                background-size:90%;
            }
            .analysis-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img2.png");
                background-size:100%;
            }
            .defect-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img3.png");
                background-size:100%;
            }
            .bottom-text {
                background-color:#fff;
                padding:1rem 0 1.8rem;
                .product-title {
                    margin-bottom:1rem;
                    font-size:1.5rem;
                    font-weight:bold;
                }
                .product-desc {
                    color:#666666;
                    font-size:1rem;
                    line-height:25px;
                    text-align:center;
                }
            }
        }
    }

    .block-content {
        max-width:var(--main-width);
        width:84%;
        margin:7.56rem auto 0;
        .content-row {
            display:flex;
            margin-bottom:4rem;
            .img-wrapper {
                width: 50%;
                display:flex;
                justify-content:center;
                align-items:center;
                img {
                    width:100%;
                }
            }
            .text-wrapper {
                width: 50%;
            }
            .block-text {
                padding:3rem 5.5rem;
                .title {
                    margin-bottom:3.18rem;
                    font-size:1.75rem;
                    font-weight:bold;
                    color:#2372e9;
                    span {
                        color:#2372E9;
                    }
                }
                .desc {
                    color:#333333;
                    line-height:30px;
                    font-size:1rem;
                    .desc-row {
                        display:flex;
                        justify-content:space-between;
                        .desc-column-value {
                            color:#2372E9;
                            font-size:1.5rem;
                        }
                        .desc-column-title {
                            color:#666;
                            margin-top:10px;
                        }
                    }
                }
            }
        }
    }
    .mobile-function {
        display:none;
    }
    .application-scenarios {
        margin-top: 6.25rem;
      .mobile-img {
        display:none;
      }
        .application-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:3.18rem;
        }
        .application-desc {
            text-align: center;
            margin:0 auto;
            letter-spacing: 1px;
            line-height:25px;
        }
        .application-content {
            display:flex;
            justify-content: space-around;
            gap: 1.875rem;
            flex-wrap: wrap;
            max-width:var(--main-width);
            width:84%;
            margin:2.375rem auto 7.5rem;
            .application-block {
                width: 30%;
                max-width: 27rem;
                min-width: 21.75rem;
                position:relative;
                display:flex;
                justify-content: center;
                align-items:center;
                overflow:hidden;
                .text {
                    position:absolute;
                    bottom:0px;
                    width:100%;
                    color:#fff;
                    text-align: center;
                    line-height: 87px;
                    background: linear-gradient( 180deg, rgba(39,39,39,0) 0%, rgba(14,14,14,0.7) 100%);
                }
            }
            .mobile-img {
              display:none;
            }
        }
    }
}

@media only screen and (max-width: 768px) {
    .container-wrapper {
        background-color:#F5F7FA;
    .layout-banner {
        height:380px !important;
        margin-top:108px;
       
        .text-block {
            transform:translate(-50%,-50%);
            left:50%;
             .title {
            font-size:24px ;
            margin-bottom:10px !important;
        }
        }
        .use-button {
            display:none;
        }
        .desc {
            text-align:center !important;
        }
        
    }
    .block-wrap {
        padding:25px 15px 0 !important;
        margin:0px !important;
        width:auto !important;
        .block-content {
        margin-top:50px !important;
        width:auto !important;
         .content-row {
        flex-wrap:wrap;
        margin-bottom:10px !important;
        background-color:#fff;
        .img-wrap {
            height:auto;
            overflow:hidden;
            img {
                width:352px;
            }
        }
        .img-wrapper,.text-wrapper {
            width:100% !important;
            flex:auto !important;
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
        .block-text {
            padding:1.5rem 0rem !important;
            .title {
            font-size:18px;
            font-weight:bold;
            text-align:center;
            margin-bottom:0.9375rem;
        }
          .desc {
              width:80%;
              margin:0 auto;
            }
        }
        .desc-row {
           justify-content:center;
           .desc-column {
            margin-right:25px;
           }
        }
         
        .draw {
            text-align:center;
            .title {
                color:#2372E9;
            }
        }
    }
      }
        .block-title {
            font-size:22px !important;
        }
        .block-title::after {
            top:40px !important;
        }
        .block-desc {
            width:auto !important;
            padding:0 15px;
            margin-top:38px !important;
            font-size:14px !important;
            margin-bottom:29px !important;
            line-height:20px !important;
        }
    }

   
    .application-scenarios {
      margin-top:0px;
      padding:40px 15px 0;
      background-color:#fff;
      .application-content {
        width:100% !important;
        gap:0 !important;
        margin:2.375rem auto !important;
      }
      .pc-img {
        display:none !important;
      }
      .mobile-img {
        display:block !important;
      }
      .application-title {
        font-size:22px !important;
        margin:0px auto !important;
        font-weight:bold;
        width:80%;
      }
     
      .application-desc {
        font-size:14px !important;
        color:#666;
      }
      .application-block {
        max-width:30% !important;
        min-width:30% !important;
        margin-bottom:20px;
        .text {
          width:108px !important;
          line-height:25px !important; 
        }
      }
      }
    }
}
</style>
